/* eslint-disable import/prefer-default-export */

import * as $report from '@tencent/we-lib-report';
import { Report, perf } from '@tencent/we-lib-report';

const cardReport = new Report({
  namespace: 'card',
  beaconOptions: false // 禁用灯塔上报
});

export function reporterReportEvent(obj) {
  cardReport.reportEvent('', obj);
}
export function reporterLog(msg) {
  perf.log(msg);
}

const MAIN_KEY = 'wegame_card';

const SUB_KEY = {
  // 通用
  idb_req: 'idb_req',
  idb_set: 'idb_set',
  show_home_page: 'show_home_page',
  jump_icenter: 'jump_icenter',
  open_manager_win: 'open_manager_win',
  jump_personal_bag: 'jump_personal_bag',
  open_introduction_win: 'open_introduction_win',

  // 图鉴页
  helper_scan_notice: 'helper_scan_notice',
  helper_change_tag: 'helper_change_tag',
  helper_show_detail_card: 'helper_show_detail_card',
  helper_card_match: 'helper_card_match',
  helper_merge: 'helper_merge',
  helper_split: 'helper_split',
  helper_task: 'helper_task',
  helper_market: 'helper_market',
  helper_game_list_popbox: 'helper_game_list_popbox',
  helper_game_list_popbox_game: 'helper_game_list_popbox_game',
  helper_badge: 'helper_badge',
  helper_badge_more: 'helper_badge_more',
  helper_open_cfg_url_window: 'helper_open_cfg_url_window',
  helper_rank: 'helper_rank',
  helper_rank_show_detail_card: 'helper_rank_show_detail_card',

  // 详情页
  detail_show_big_img: 'detail_show_big_img',
  detail_publish_feeds: 'detail_publish_feeds',
  detail_auto_publish_feeds: 'detail_auto_publish_feeds', // 一键分享
  detail_buy: 'detail_buy', // 卡牌详情购买
  detail_sell: 'detail_sell', // 卡牌详情出售
  detail_open_cfg_url_window: 'detail_open_cfg_url_window',
  detail_jump_home_page: 'detail_jump_home_page',
  detail_prev: 'detail_prev',
  detail_next: 'detail_next',
  detail_change_nav: 'detail_change_nav',
  detail_favore_card: 'detail_favore_card',
  detail_send_comment: 'detail_send_comment',
  detail_change_barrage: 'detail_change_barrage',
  detail_goto_comment: 'detail_goto_comment',

  // 展示柜
  cabinet_show: 'cabinet_show',
  cabinet_upvote: 'cabinet_upvote', // 展示柜点赞
  cabinet_change_game: 'cabinet_change_game',
  cabinet_game_more: 'cabinet_game_more',
  cabinet_prev: 'cabinet_prev',
  cabinet_next: 'cabinet_next',
  cabinet_open_detail_page: 'cabinet_open_detail_page',
  cabinet_jump_home_page: 'cabinet_jump_home_page', // 跳转图鉴页
  cabinet_admin_change_game: 'cabinet_admin_change_game',
  cabinet_admin_active_change_game_index:
    'cabinet_admin_active_change_game_index',
  cabinet_admin_visible: 'cabinet_admin_visible',
  cabinet_admin_search: 'cabinet_admin_search',
  cabinet_admin_add_card: 'cabinet_admin_add_card',
  cabinet_admin_remove_card: 'cabinet_admin_remove_card',
  cabinet_admin_ok: 'cabinet_admin_ok',

  // 合成分解等
  abc_change_tab: 'abc_change_tab',

  merge_show: 'merge_show',
  merge_select_game: 'merge_select_game',
  merge_merge: 'merge_merge', // 合成卡牌
  merge_addcard: 'merge_addcard',
  merge_deletecard: 'merge_deletecard',
  merge_selecebox: 'merge_selecebox',
  merge_buybox: 'merge_buybox',
  merge_mybox: 'merge_mybox',
  merge_openbox_page: 'merge_openbox_page',
  merge_openbox: 'merge_openbox',
  merge_openbox_choose_card: 'merge_openbox_choose_card',
  merge_openbox_continue: 'merge_openbox_continue',

  split_show: 'split_show',
  split_select_game: 'split_select_game',
  split_split: 'split_split', // 分解卡牌
  split_addcard: 'split_addcard',
  split_deletecard: 'split_deletecard',
  split_open_cfg_url_window: 'split_open_cfg_url_window',
  split_cancel_select_card: 'split_cancel_select_card',

  task_show: 'task_show',
  task_select_game: 'task_select_game',
  task_tab: 'task_tab',
  task_exchange_reward: 'task_exchange_reward',
  task_history_edit_game_role: 'task_history_edit_game_role',
  task_history_edit_address: 'task_history_edit_address',
  task_history_delivery_reward: 'task_history_delivery_reward',
  task_exchange_reward_edit_game_role: 'task_exchange_reward_edit_game_role',
  task_exchange_reward_edit_address: 'task_exchange_reward_edit_address',
  task_lottery_exchange_reward: 'task_lottery_exchange_reward',
  task_lottery_delivery_reward: 'task_lottery_delivery_reward',
  task_show_detail_card: 'task_show_detail_card',

  badge_show: 'badge_show',
  badge_select_game: 'badge_select_game',
  badge_home_add_card: 'badge_home_add_card',
  badge_auto_filling: 'badge_auto_filling',
  badge_unlock_popbox: 'badge_unlock_popbox',
  badge_unlock: 'badge_unlock',
  badge_pool_change_tab_lv: 'badge_pool_change_tab_lv',
  badge_pool_add_card: 'badge_pool_add_card',
  badge_pool_ok: 'badge_pool_ok',
  badge_pool_cancel: 'badge_pool_cancel',

  play_intro_open_merge_window: 'play_intro_open_merge_window'
};

export const $cardReport = {
  // 缓存数据请求
  IDB_REQ: $report.init({
    main: 'wegame_idb',
    sub: 'req',
    keys: ['cgi', 'is_cache']
  }),
  // 缓存数据设置
  IDB_SET: $report.init({
    main: 'wegame_idb',
    sub: 'set',
    keys: ['cgi', 'is_success']
  }),
  // 跳转到个人主页
  SHOW_HOME_PAGE: $report.init({
    main: MAIN_KEY,
    sub: SUB_KEY.show_home_page,
    keys: ['game_id']
  }),
  // 跳转到个人主页
  JUMP_ICENTER: $report.init({
    main: MAIN_KEY,
    sub: SUB_KEY.jump_icenter,
    keys: ['tgp_id', 'from']
  }),
  // 打开展示柜设置窗口
  OPEN_MANAGER_WIN: $report.init({
    main: MAIN_KEY,
    sub: SUB_KEY.open_manager_win,
    keys: ['from']
  }),
  // 跳转到个人背包
  JUMP_PERSONAL_BAG: $report.init({
    main: MAIN_KEY,
    sub: SUB_KEY.jump_personal_bag,
    keys: ['from']
  }),
  // 打开卡牌介绍页窗口
  OPEN_INTRODUCTION_WIN: $report.init({
    main: MAIN_KEY,
    sub: SUB_KEY.open_introduction_win,
    keys: ['from']
  }),

  // 图鉴页
  HELPER: {
    SCAN_NOTICE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_scan_notice,
      keys: ['game_id']
    }),
    // 切换标签
    CHANGE_TAG: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_change_tag,
      keys: ['game_id', 'navid']
    }),
    SHOW_DETAIL_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_show_detail_card,
      keys: ['game_id', 'card_id']
    }),
    OPEN_CARD_MATCH: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_card_match,
      keys: ['game_id']
    }),
    MERGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_merge,
      keys: ['game_id']
    }),
    SPLIT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_split,
      keys: ['game_id']
    }),
    TASK: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_task,
      keys: ['game_id']
    }),
    MARKET: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_market,
      keys: ['game_id']
    }),
    GAME_LIST_POPBOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_game_list_popbox,
      keys: ['game_id']
    }),
    GAME_LIST_POPBOX_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_game_list_popbox_game,
      keys: ['game_id']
    }),
    BADGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_badge,
      keys: ['game_id']
    }),
    BADGE_MORE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_badge_more,
      keys: ['game_id']
    }),
    OPEN_CFG_URL_WINDOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_open_cfg_url_window,
      keys: ['game_id']
    }),
    RANK: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_rank,
      keys: ['game_id', 'type']
    }),
    RANK_SHOW_DETAIL_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.helper_rank_show_detail_card,
      keys: ['game_id', 'card_id']
    })
  },

  // 卡牌详情的数据上报
  DETAIL: {
    // 查看大图
    SHOW_BIG_IMG: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_show_big_img,
      keys: []
    }),
    // 一键分享
    AUTO_PUBLISH_FEEDS: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_auto_publish_feeds,
      keys: []
    }),
    // 发布feeds
    PUBLISH_FEEDS: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_publish_feeds,
      keys: []
    }),
    // 卡牌详情购买
    BUY: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_buy,
      keys: ['game_id', 'card_id']
    }),
    // 卡牌详情出售
    SELL: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_sell,
      keys: ['game_id', 'card_id']
    }),
    // 卡牌详情跳转
    OPEN_CFG_URL_WINDOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_open_cfg_url_window,
      keys: ['game_id', 'card_id']
    }),
    JUMP_HOME_PAGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_jump_home_page,
      keys: ['game_id', 'card_id']
    }),
    PREV: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_prev,
      keys: ['game_id', 'card_id']
    }),
    NEXT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_next,
      keys: ['game_id', 'card_id']
    }),
    CHANGE_NAV: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_change_nav,
      keys: ['game_id', 'nav_id']
    }),
    FAVORE_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_favore_card,
      keys: ['game_id', 'card_id']
    }),
    SEND_COMMENT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_send_comment,
      keys: ['game_id', 'card_id']
    }),
    CHANGE_BARRAGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_change_barrage,
      keys: ['enabled']
    }),
    GOTO_COMMENT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.detail_goto_comment,
      keys: ['game_id', 'card_id']
    })
  },

  CABINET: {
    SHOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_show,
      keys: ['isself']
    }),
    // 展示柜点赞
    UPVOTE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_upvote,
      keys: ['isself']
    }),
    CHANGE_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_change_game,
      keys: ['game_id']
    }),
    GAME_MORE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_game_more,
      keys: ['isself']
    }),
    PREV: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_prev,
      keys: ['game_id']
    }),
    NEXT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_next,
      keys: ['game_id']
    }),
    OPEN_DETAIL_PAGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_open_detail_page,
      keys: ['game_id', 'card_id']
    }),
    JUMP_HOME_PAGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_jump_home_page,
      keys: ['game_id']
    }),
    ADMIN_CHANGE_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_change_game,
      keys: ['game_id']
    }),
    ADMIN_ACTIVE_CHANGE_GAME_INDEX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_active_change_game_index,
      keys: []
    }),
    ADMIN_VISIBLE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_visible,
      keys: ['game_id']
    }),
    ADMIN_SEARCH: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_search,
      keys: ['game_id']
    }),
    ADMIN_ADD_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_add_card,
      keys: ['game_id']
    }),
    ADMIN_REMOVE_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_remove_card,
      keys: ['game_id']
    }),
    ADMIN_OK: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.cabinet_admin_ok,
      keys: ['game_id']
    })
  },

  ABC: {
    CHANGE_TAB: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.abc_change_tab,
      keys: ['tab']
    })
  },

  MERGE: {
    SHOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_show,
      keys: ['game_id']
    }),
    SELECT_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_select_game,
      keys: ['game_id']
    }),
    MERGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_merge,
      keys: ['game_id']
    }),
    ADD_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_addcard,
      keys: ['game_id']
    }),
    DELETE_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_deletecard,
      keys: ['game_id']
    }),
    SELECT_BOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_selecebox,
      keys: ['game_id', 'box_level']
    }),
    BUY_BOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_buybox,
      keys: ['game_id', 'box_level']
    }),
    MY_BOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_mybox,
      keys: ['game_id']
    }),
    OPEN_BOX_PAGE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_openbox_page,
      keys: ['game_id', 'box_level']
    }),
    OPEN_BOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_openbox,
      keys: ['game_id', 'box_level']
    }),
    OPEN_BOX_CHOOSE_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_openbox_choose_card,
      keys: ['game_id', 'box_level']
    }),
    OPEN_BOX_CONTINUE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.merge_openbox_continue,
      keys: ['game_id', 'box_level']
    })
  },

  SPLIT: {
    SHOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_show,
      keys: ['game_id']
    }),
    SELECT_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_select_game,
      keys: ['game_id']
    }),
    SPLIT: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_split,
      keys: ['game_id']
    }),
    ADD_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_addcard,
      keys: ['game_id']
    }),
    DELETE_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_deletecard,
      keys: ['game_id']
    }),
    OPEN_CFG_URL_WINDOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_open_cfg_url_window,
      keys: ['game_id']
    }),
    CANCEL_SELECT_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.split_cancel_select_card,
      keys: ['game_id']
    })
  },

  TASK: {
    SHOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_show,
      keys: ['game_id']
    }),
    SELECT_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_select_game,
      keys: ['game_id']
    }),
    TAB: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_tab,
      keys: ['game_id', 'tab']
    }),
    EXCHANGE_REWARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_exchange_reward,
      keys: ['game_id', 'task_id']
    }),
    HISTORY_EDIT_GAME_ROLE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_history_edit_game_role,
      keys: ['game_id']
    }),
    HISTORY_EDIT_ADDRESS: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_history_edit_address,
      keys: ['game_id']
    }),
    HISTORY_DELIVERY_REWARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_history_delivery_reward,
      keys: ['game_id']
    }),
    EXCHANGE_REWARD_EDIT_GAME_ROLE: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_exchange_reward_edit_game_role,
      keys: ['game_id']
    }),
    EXCHANGE_REWARD_EDIT_ADDRESS: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_exchange_reward_edit_address,
      keys: ['game_id']
    }),
    LOTTERY_EXCHANGE_REWARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_lottery_exchange_reward,
      keys: ['game_id']
    }),
    LOTTERY_DELIVERY_REWARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_lottery_delivery_reward,
      keys: ['game_id']
    }),
    SHOW_DETAIL_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.task_show_detail_card,
      keys: ['game_id', 'card_id']
    })
  },

  BADGE: {
    SHOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_show,
      keys: ['game_id']
    }),
    SELECT_GAME: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_select_game,
      keys: ['game_id']
    }),
    HOME_ADD_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_home_add_card,
      keys: ['game_id']
    }),
    AUTO_FILLING: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_auto_filling,
      keys: ['game_id']
    }),
    UNLOCK_POPBOX: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_unlock_popbox,
      keys: ['game_id']
    }),
    UNLOCK: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_unlock,
      keys: ['game_id']
    }),
    POOL_CHANGE_TAB_LV: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_pool_change_tab_lv,
      keys: ['game_id']
    }),
    POOL_ADD_CARD: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_pool_add_card,
      keys: ['game_id']
    }),
    POOL_OK: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_pool_ok,
      keys: ['game_id']
    }),
    POOL_CANCEL: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.badge_pool_cancel,
      keys: ['game_id']
    })
  },

  PLAY_INTRO: {
    OPEN_MERGE_WINDOW: $report.init({
      main: MAIN_KEY,
      sub: SUB_KEY.play_intro_open_merge_window,
      keys: ['game_id']
    })
  }
};

/* eslint-enable */
